(function () {
  'use strict';

  angular.module('app').service('ExchangeRateModalService', ExchangeRateModalService);

  ExchangeRateModalService.$inject = ['ModalService'];

  function ExchangeRateModalService(ModalService) {
    let service = {
      openExchangeRateListModal: openExchangeRateListModal,
    };

    return service;

    //////////////

    function openExchangeRateListModal(
      currency,
      companyId,
      companyCountryCode,
      companyBaseCurrency,
      companyTimeZoneUtc,
      mode,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl: './app/ajs/exchange-rates/modals/exchange-rate-list-modal.html',
        controller: ExchangeRateListModalCtrl,
        controllerAs: 'vm',
        inputs: {
          currency: currency,
          companyId: companyId,
          companyCountryCode: companyCountryCode,
          companyBaseCurrency: companyBaseCurrency,
          companyTimeZoneUtc: companyTimeZoneUtc,
          mode: mode,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      ExchangeRateListModalCtrl.$inject = [
        'ExchangeRateService',
        'AbilityService',
        'ModalWindowConfirmService',
        'CONFIGURATIONS',
        'moment',
        'UtilService',
        'currency',
        'companyId',
        'companyCountryCode',
        'companyBaseCurrency',
        'companyTimeZoneUtc',
        'mode',
        'successCallback',

        // Angular downgraded service
        'currencyService',
      ];
    }

    function ExchangeRateListModalCtrl(
      ExchangeRateService,
      AbilityService,
      ModalWindowConfirmService,
      CONFIGURATIONS,
      moment,
      UtilService,
      currency,
      companyId,
      companyCountryCode,
      companyBaseCurrency,
      companyTimeZoneUtc,
      mode,
      successCallback,

      // Angular downgraded service
      currencyService
    ) {
      const vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canList: AbilityService.can('index_exchangerate_accountadmin'),
        canCreate: AbilityService.can('create_exchangerate_accountadmin'),
      };

      // public properties
      // -----------------------
      vm.currency = currency;
      vm.companyId = companyId;
      vm.companyCountryCode = companyCountryCode;
      vm.companyBaseCurrency = companyBaseCurrency;
      vm.companyTimeZoneUtc = companyTimeZoneUtc;

      // console.log(vm.companyTimeZoneUtc);

      vm.allowAutomaticExchangeRate = false;
      vm.allowTodayExchangeRateUpdate = false;

      // private properties
      let today = moment().startOf('day');

      if (mode === 'create') {
        // vm.addExchangeRate(); // Not working in modals
        addExchangeRate();
      } else {
        // view
        if (vm.currency.enable_automatic_exchange_rate) {
          let today = CONFIGURATIONS.TODAY_DATE;

          if (vm.currency.lastExchangeRate.from < today) {
            vm.allowTodayExchangeRateUpdate = true;
          }
        }

        getCurrencyExchangeRates('');
      }

      // console.log('companyCountryCode: ', vm.companyCountryCode);
      // console.log('companyBaseCurrency.code: ', vm.companyBaseCurrency.code);
      // console.log('vm.currency.code: ', vm.currency.code);

      if (
        vm.companyCountryCode === 'CR' &&
        vm.companyBaseCurrency.code === 'CRC' &&
        (vm.currency.code === 'USD' || vm.currency.code === 'EUR')
      ) {
        vm.allowAutomaticExchangeRate = true;
      }

      // console.log('allowAutomaticExchangeRate: ', vm.allowAutomaticExchangeRate);

      vm.enableAutomaticExchangeRate = vm.currency.enable_automatic_exchange_rate;
      vm.originalEnableAutomaticExchangeRate = angular.copy(vm.enableAutomaticExchangeRate);

      // public methods
      // -----------------------
      vm.addExchangeRate = function () {
        addExchangeRate();
      };

      vm.cancel = function () {
        vm.detailMode = false;
      };

      vm.onShowExchangeRate = function (exchangeRate) {
        vm.detailMode = true;
        vm.exchangeRate = exchangeRate;

        getExchangeRate(exchangeRate); // for getting the currency_used_in_active_transactions
      };

      vm.onExchangeRateDeleted = function () {
        getCurrencyExchangeRates('');
      };

      vm.onExchangeRateSaved = function (exchangeRate) {
        getCurrencyExchangeRates(exchangeRate);
        vm.onExchangeRateCancelled();

        successCallback(); // vm.currency
      };

      vm.onExchangeRateCancelled = function () {
        vm.detailMode = false;
        vm.exchangeRate = {}; // null
      };

      vm.setAutomaticExchangeRate = function () {
        let confirmCallback = () => {
          vm.currency.enable_automatic_exchange_rate = vm.enableAutomaticExchangeRate;

          vm.sendingAutomaticExchangeRate = true;

          currencyService
            .setAutomaticExchangeRate(vm.currency, vm.companyTimeZoneUtc)
            .subscribe((response) => {
              if (response) {
                // Success
                vm.currency.exchange_rates = response.exchange_rates;

                getCurrencyExchangeRates('');
                successCallback(); // vm.currency
                // getCurrencyExchangeRates('');
              } else {
                vm.enableAutomaticExchangeRate = vm.originalEnableAutomaticExchangeRate;
                vm.currency.enable_automatic_exchange_rate = vm.enableAutomaticExchangeRate;
              }

              vm.sendingAutomaticExchangeRate = false;
            });
        };

        const cancelCallback = function () {
          vm.enableAutomaticExchangeRate = vm.originalEnableAutomaticExchangeRate;
        };

        let params = {
          title: vm.enableAutomaticExchangeRate
            ? 'ENABLE_AUTOMATIC_EXCHANGE_RATE'
            : 'DISABLE_AUTOMATIC_EXCHANGE_RATE',
          body: vm.enableAutomaticExchangeRate
            ? 'ENABLE_AUTOMATIC_EXCHANGE_RATE_DESC'
            : 'DISABLE_AUTOMATIC_EXCHANGE_RATE_DESC',
          preventModalClose: true,
        };

        ModalWindowConfirmService.open(params, confirmCallback, cancelCallback);
      };

      vm.setTodayExchangeRate = function () {
        vm.settingTodayExchangeRate = true;
        currencyService.setAutomaticExchangeRate(vm.currency).subscribe((response) => {
          if (response) {
            // Success
            vm.allowTodayExchangeRateUpdate = false;

            getCurrencyExchangeRates('');
            successCallback();
          }

          vm.settingTodayExchangeRate = false;
        });
      };

      // private methods
      // -----------------------
      function getCurrencyExchangeRates(selectedItem) {
        let filterCriteria = ExchangeRateService.getFilterCriteria();

        filterCriteria.currency_id = vm.currency.id;
        filterCriteria.skip_check_role = true;

        vm.loadingItems = true;
        ExchangeRateService.getExchangeRates(filterCriteria).then(function (data) {
          vm.currencyExchangeRates = data.items;
          vm.meta = data.meta;

          vm.currencyExchangeRates.map((x) => {
            x.isCurrentRate = today.isBetween(x.from, x.to, undefined, '[]') ? true : false;
          });

          if (selectedItem) {
            vm.UtilService.itemListChanged(selectedItem.id);
          }

          vm.loadingItems = false;
        });
      }

      function getExchangeRate(exchangeRate) {
        vm.loadingItem = true;
        ExchangeRateService.getExchangeRate(exchangeRate.id, { company_id: vm.companyId }).then(
          function (data) {
            vm.exchangeRate.currency_used_in_active_transactions =
              data.currency_used_in_active_transactions;

            vm.loadingItem = false;
          }
        );
      }

      function addExchangeRate() {
        vm.detailMode = true;
        vm.exchangeRate = {};
      }
    }
  }
})();
